<template>
  <div class="matrix" @mouseleave="closeMatrix">
    <div class="jz" id="box_div_editor_client1" v-show="visible">
      <i class="carts"/>
      <div id="div_MatrixBlock" class="jz_menuDiv">
        <ul class="jz_IMEMenu">
          <!-- <li><a href="javascript:void(0)" @click="insertTable(2,2)"><i class="jz_icon jz2"/>插入2*2矩阵</a></li> -->
          <!-- <li><a href="javascript:void(0)" @click="insertTable(3,3)"><i class="jz_icon jz3"/>插入3*3矩阵</a></li> -->
          <li><a href="javascript:void(0)" @click="showDialog = true"><i class="jz_icon jz3"/>自定义矩阵</a></li>
          <li id="btn_DeleteMatrix">
            <a href="javascript:void(0)" @click="deleteMatrix"><i class="jz_icon jzd"/>删除当前矩阵</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="dialogCustomMatrix" v-if="showDialog">
      <div class="tit"><h2>消息</h2></div>
      <div class="tc">
        <div class="kuang">
          <table>
            <tbody>
            <tr>
              <td colspan="4">请输入自定义矩阵尺寸：</td>
            </tr>
            <tr>
              <th>行数：</th>
              <td>
                <select id="selRow">
                  <option v-for="i in 10" :value="i" :key="i">{{ i }}</option>
                </select>
              </td>
              <th>列数：</th>
              <td>
                <select id="selCol">
                  <option v-for="i in 10" :value="i" :key="i">{{ i }}</option>
                </select>
              </td>
            </tr>
            </tbody>
          </table>
          <div class="button clearfix">
            <button class="sure" @click="customMatrix">确认</button>
            <button class="close" @click="showDialog = false">关闭</button>
          </div>
        </div>
      </div>
      <div class="tc_bottom"></div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'Matrix',
    props: {
      visible: { type: Boolean, default: false },
      toggleTable: { type: Function, default: () => null },
    },
    data() {
      return {
        showDialog: false
      }
    },
    methods: {
      insertTable(row, col) {
        this.$emit('toggleTable', row, col)
      },
      closeMatrix() {
        this.$emit('update:visible', false)
      },
      customMatrix() {
        let row = parseInt($('.dialogCustomMatrix #selRow').val())
        let col = parseInt($('.dialogCustomMatrix #selCol').val())
        this.$emit('toggleTable', row, col)
        this.$emit('update:visible', false)
        this.showDialog = false
      },
      deleteMatrix() {
        this.$emit('delTable', true)
      }
    }
  }
</script>
<style lang="scss" scoped>
  $bgUrl: '~@/assets/images/formula/';
  .matrix {
    .jz {
      width: 125px;
      position: absolute;
      top: 29px;
      left: 124px;

      .carts {
        width: 125px;
        height: 8px;
        background: url($bgUrl + 'jt.png') no-repeat -27px 0;
        display: block
      }

      .jz_menuDiv {
        background: #FFF;
        border: 1px solid #c1cee3;
        border-top: none;

        .jz_IMEMenu {
          background: #fff;
          margin: 0;
          padding: 0;

          li {
            height: 26px;
            line-height: 26px;
            width: 122px;
            border-top: 1px solid #fff;
            border-bottom: 1px solid #fff;

            a {
              color: #000;
              width: 112px;
              text-decoration: none;
              display: block;
              margin: 0 auto;
              box-shadow: none;
              font-size:14px;
            }

            &:hover, &:active {
              background-color: #fee7a3;
              border-color: #ffbd69;
            }

            &#btn_DeleteMatrix {
              /*display: none;*/
            }
          }
        }
      }

      .jz_icon {
        display: inline-block;
        margin-right: 5px;
        vertical-align: middle;
        background: url($bgUrl + 'icon.png') no-repeat;
        width: 15px;
        height: 15px;
        overflow: hidden;

        &.jz2 {
          background-position: -89px -21px
        }

        &.jz3 {
          background-position: -104px -21px
        }

        &.jzd {
          background-position: -119px -21px;
        }
      }
    }

    .dialogCustomMatrix {
      width: 560px;
      overflow: hidden;
      z-index: 999999;
      position: absolute;
      top: 40%;
      right: 50%;
      margin-right: -280px;

      .tit {
        height: 37px;
        width: 555px;
        background: url($bgUrl + 'tit.gif') no-repeat;

        h2 {
          line-height: 37px;
          font-size: 16px;
          font-weight: bold;
          color: #0b3b8c;
          padding-left: 20px;
        }
      }

      .tc {
        width: 555px;
        border-left: 1px solid #88b3e9;
        border-right: 1px solid #88b3e9;
        background: #fff;
        padding: 20px 0;

        .kuang {
          width: 497px;
          height: 237px;
          background: url($bgUrl + 'tc.gif') no-repeat;
          overflow: hidden;
          margin: 10px auto 0;

          table {
            width: 90%;
            font-size: 12px;
            margin: 10px auto 0;

            th {
              width: 80px;
              text-align: right;
            }

            td {
              height: 24px;
              line-height: 24px;
            }
          }

          .button {
            margin: 20px auto;
            width: 120px;

            .sure {
              padding: 2px 5px;
              float: left
            }

            .close {
              padding: 2px 5px;
              float: right
            }
          }
        }
      }

      .tc_bottom {
        background: url($bgUrl + 'tc_b.gif') no-repeat;
        width: 555px;
        height: 4px;
      }
    }

  }
</style>
